const domainRegexp = /(?<=https?:\/\/(?:www\.)?)(?!www\.).+?(?=\/|$)/gi;

export const formatSiteDomain = (v: string) => {
  const match = v.match(domainRegexp);
  if (match && match.length) {
    return match[0];
  }
  return '';
};
